import apiClient from "../../services/apiClient";
import { useEffect, useState } from "react";
import { Table } from "antd";
import { LineChart } from '@mui/x-charts/LineChart';
import { set } from "date-fns";

const GovSecYeild = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [years, setYears] = useState([]);
    const [wtdAvgYield, setWtdAvgYield] = useState([]);
    const [chartData, setChartData] = useState([]);


    const fetchGovSecYeild = async () => {
        try {
            const response = await apiClient.get(baseUrl + "/rbi/yeild/g-sec");
            console.log(response.data);

            // Dynamically create columns based on the keys of the first object
            if (response.data.length > 0) {
                const sortedData = [...response.data].sort((a, b) => a.years - b.years);

                const maturityDates = sortedData.map(item => item.wtdAvgYield);
                const years = sortedData.map(item => item.years);

                setYears(years);
                setWtdAvgYield(maturityDates);
            }
        } catch (error) {
            console.error("Error fetching RBI Gov Securities data:", error);
        }
    };
    useEffect(() => {


        fetchGovSecYeild();
    }, []);


    return (
        <div>

            <h1>Government Security Yeild</h1>


            <LineChart
                xAxis={[
                    {
                        data: years,
                        label: "Maturity (Years)",
                    },
                ]}
                yAxis={[
                    {
                        label: "Yield (%)",
                    },
                ]}
                series={[
                    {
                        data: wtdAvgYield,
                        name: "Weighted Avg Yield",
                    },
                ]}
                height={500}
                width={1000}
            />
        </div>

    );

}

export default GovSecYeild;